<template>
	<div>
		<modal size="lg" ref="pModal" title="Gerenciar Propostas" static>
			<div v-if="assets != null" slot="body">
				<ccHeader :dIn="prop" :assets="assets" /><br />
				<ul class="nav nav-tabs">
					<li :class="{ active: active == 0 }" @click="active = 0">
						<a>Configurações</a>
					</li>
					<li :class="{ active: active == 1 }" @click="active = 1">
						<a>Lista de serviços</a>
					</li>
					<li :class="{ active: active == 2 }" @click="active = 2">
						<a>Histórico</a>
					</li>
				</ul>
				<div v-show="active == 0" class="col-sm-12">
					<br />
					<settings :dIn="prop" :assets="assets" />
				</div>
				<div v-show="active == 1" class="col-sm-12">
					<br />
					<services ref="services" :dIn="prop" :assets="assets" />
				</div>
				<div v-show="active == 2" class="col-sm-12">
					<br />
					<history
						:dIn="prop"
						:assets="assets"
						@update:assets="updateAssets"
					/>
				</div>
				<div class="clearfix"></div>
				<div class="row">
					<div class="col-sm-12" v-if="!prop.renovarContrato">
						<label class="checkbox-inline">
							<input type="checkbox" v-model="prop.new" />
							Marcar esse contrato como novo
						</label>
					</div>
					<div class="col-sm-12" v-if="prop.renovarContrato">
						<label class="checkbox-inline">
							<input type="checkbox" v-model="prop.renew" />
							Gerar nova proposta
						</label>
					</div>
				</div>
				<div class="clearfix"></div>
				<!-- <pre>{{assets}}</pre> -->
			</div>
			<div slot="footer">
				<div class="pull-left" v-if="prop.cod_vendedor != '9999'">
					<button
						v-if="validadeProps && prop.renew"
						class="btn btn-warning"
						@click="gerarNovaProposta"
					>
						<i class="fa fa-file-text-o"></i>
						Gerar nova proposta
					</button>
					<button
						v-else-if="validadeProps"
						class="btn btn-danger"
						@click="gerarContrato"
					>
						<i class="fa fa-file-text-o"></i>
						Gerar Contrato
					</button>
					<button v-else class="btn btn-default" disabled>
						<i class="fa fa-file-text-o"></i>
						Gerar Contrato
					</button>
				</div>
				<button
					type="button"
					class="btn btn-default"
					@click="$refs.pModal.close()"
				>
					<i class="fa fa-close"></i> Fechar
				</button>

				<template v-if="!saving">
					<button
						type="button"
						class="btn btn-primary"
						@click="savarProposta"
					>
						<i class="fa fa-save"></i> Salvar
					</button>
				</template>
				<template v-else>
					<button class="btn btn-default" disabled>
						<i class="fa fa-spin fa-spinner"></i> Salvando...
					</button>
				</template>
			</div>
		</modal>
		<md-ativacao ref="mdAtivacao" />
	</div>
</template>
<script>
	import modal from 'app/modal';
	import clone from 'js/clone';
	import reset from '../javascript/reset.js';
	import WBS from 'js/http';
	import estado from 'js/estados';
	import toastr from 'toastr';

	// import de components do modal
	import ccHeader from './components/header.vue';
	import settings from './components/settings.vue';
	import services from './components/services.vue';
	import history from './components/history.vue';
	import MdAtivacao from './components/mdAtivacao.vue';

	export default {
		name: 'MDPropostal',
		components: {
			modal,
			settings,
			ccHeader,
			services,
			history,
			MdAtivacao,
		},
		data() {
			return {
				prop: clone(reset),
				assets: null,
				active: 0,
				loaded: false,
				saving: false,
				regioes: null,

				dActivation: {},
			};
		},
		watch: {
			'prop.cnpj': function (val) {
				if (val != '' && !this.loaded) {
					let cli = this.assets.clientes.find(
						(item) => item.cnpj == val
					);
					if (cli != undefined) this.prop.regiao = cli.regiao;
				}
				this.loaded = false;
			},
			'prop.regiao': function (val) {
				if (val != '') {
					let reg = this.regioes.find((item) => item.regiao == val);
					if (reg != undefined)
						this.prop.dia_pagamento = reg.vencimento
							.toString()
							.padStart(2, '0');
				}
				this.loaded = false;
			},
		},
		computed: {
			validadeProps() {
				if (
					this.prop.cnpj != '' &&
					this.prop.data != '' &&
					this.prop.cod_vendedor != '' &&
					this.prop.cod_categoria != '' &&
					this.prop.cod_tipprop != '' &&
					this.prop.regiao != '' &&
					this.prop.list_services.length >= 1
				)
					return true;
				return false;
			},
			newIsSet() {
				if (this.prop.new) {
					return true;
				}
				return false;
			},
		},
		methods: {
			open(data = null) {
				this.loaded = true;
				if (data == null) this.prop = clone(reset);
				else this.prop = clone(data);
				this.$refs.pModal.open();
			},

			updateAssets(updatedAssets) {
				this.prop = clone(updatedAssets);
				this.$refs.pModal.open();
				this.$emit('update');
				console.log('Dados atualizados:', updatedAssets);
			},

			updateAssetsClientes(data) {
				// console.log(data)
				let index = this.assets.clientes.findIndex(
					(emp) => emp.cnpj == data.cnpj
				);
				if (index == -1) this.assets.clientes.push(data);
				this.prop.cnpj = data.cnpj;
			},

			simpleSave(proposta, dActivation = null) {
				// console.log(this.prop);
				// return false;
				let dataSend = {
					data: this.prop,
					proposta: proposta,
					dActivation: dActivation,
					totalProp: parseFloat(this.$refs.services.getTotal).toFixed(
						2
					),
				};
				WBS.send('private-save-sstPropostals', dataSend, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Salvo com sucesso!');
						this.$refs.pModal.close();
						this.$emit('update');
					} else {
						toastr.error('Erro inesperado ao salvar!');
						console.log(resp);
					}
					this.saving = false;
				});
			},

			validateProposta(callback) {
				if (this.prop.cnpj == '') {
					toastr.warning('Defina uma empresa!');
					this.saving = false;
				} else if (this.prop.cod_vendedor == '') {
					toastr.warning('Defina um vendedor');
					this.saving = false;
				} else if (this.prop.list_services.length == 0) {
					toastr.warning('É necessário ao menos 1 serviço!');
					this.saving = false;
				} else {
					callback();
				}
			},

			gerarContrato() {
				this.validateProposta(() => {
					this.$refs.mdAtivacao
						.open(this.prop.cnpj)
						.then((dActivation) => {
							// console.log(dActivation);
							this.simpleSave(1, dActivation);
						})
						.catch((err) => {});
				});
			},

			gerarNovaProposta() {
				this.validateProposta(() => {
					WBS.send(
						'public-custom-scnpj',
						{ cnpj: this.prop.cnpj },
						(resp) => {
							if (resp.status == 'success') {
								this.dActivation = {
									contato: resp.data.contato,
									contatos: resp.data.contatos,
									razao_social: resp.data.razao_social,
									saveClienteData: '',
									sendMailActivation: '',
									codInterno: '',
									templateSelecionado: '',
								};
								// console.log(this.dActivation);
								this.simpleSave(1, this.dActivation);
							} else {
								this.reject('E67: CNPJ Não localizado!');
							}
						}
					);
				});
			},

			savarProposta() {
				this.saving = true;
				this.validateProposta(() => {
					this.simpleSave(0);
				});
			},
		},
		mounted() {
			WBS.send('protected-read-mdPropsAssets', (resp) => {
				if (resp.status == 'success' && resp.data != undefined) {
					resp.data.estados = estado;
					this.assets = resp.data;
				}
			});
			WBS.send('protected-read-assetsPropostas', (resp) => {
				if (resp.status == 'success' && resp.data != undefined) {
					this.regioes = resp.data.regioes;
				}
			});
		},
	};
</script>
<style scoped>
	.nav > li > a {
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/proposals/components/modal.vue